module.exports = __webpack_public_path__ + "img/ULU_logo.41276620.png";